import {Question} from "./question";
import { QuestionSetLabel } from "./question-set-label";
import { Utility } from "app/shared/models/utility";

export abstract class ListQuestion extends Question {
    private _customLabels:QuestionSetLabel[];

    public constructor() {
        super();
        this._customLabels = [];
    }

    public get CustomLabels() {
        return this._customLabels;
    }
    public set CustomLabels(v:QuestionSetLabel[]) {
        this._customLabels = v;
    }

    public addLabel(lbl:QuestionSetLabel) {
        this._customLabels.push(lbl);
    }

    public removeLabel(lbl:QuestionSetLabel) {
        this._customLabels = this._customLabels.filter(l => l.id != lbl.id);
    }

    public shiftUpLabel(lbl:QuestionSetLabel) {
        Utility.shiftCollectionUp(this._customLabels, lbl);
    }

    public shiftDownLabel(lbl:QuestionSetLabel) {
        Utility.shiftCollectionDown(this._customLabels, lbl);
    }

    public abstract get answerDisplayText();

	public abstract get answerForSave();

	public abstract setSavedAnswer(data:any, labels:QuestionSetLabel[]);

	public abstract hasAnswer(answer:any);

	public abstract get isFilledOut() : boolean;

}


// WEBPACK FOOTER //
// ./src/app/shared/models/list-question.ts